"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // SuccessMessageForSaving
  SuccessMessageForSaving: 'Your changes have been saved.',
  ErrorMessageFromServer: 'Bad response from server.',
  PARAM_TYPE: {
    QUERY_STRING: 'Query String',
    PATH_VARIABLE: 'Path Variabel',
    BOTH: 'Both'
  },
  HTTP_GET: 'GET',
  HTTP_POST: 'POST',
  HTTP_PUT: 'PUT',
  HTTP_DELETE: 'DELETE',
  APPLICATION_JSON: 'application/json'
};
exports.default = _default;